
import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { catchError, map, Observable } from "rxjs";
import { DatePipe } from "@angular/common";
import { ModalWithInputTextComponent } from "src/app/components/modal-with-input-text/modal-with-input-text.component";
import { ModalConfirmationComponent } from "src/app/components/modal-confirmation/modal-confirmation.component";
import { Attachment, Developer, Locations, Ods, ProjectStatus, ProjectStatusCode, ProjectUpdateStatus, PsaProjectData } from "src/app/shared/interfaces/psa-project-register";
import { PsaAuthorizationService } from "src/app/services/auth/psa-authorization.service";
import { AppModalService } from "src/app/shared/services/app-modal.service";
import { AppToastService } from "src/app/shared/services/app-toast.service";
import { ProjectService } from "../../services/project.service";
import { ProjectBaselineActivityService } from "../../services/project-baseline-activity.service";
import { ProjectMethodologiesService } from "../../services/project-methodology.service";
import { formatCPFOrCNPJ } from "src/app/helpers/utils/cpf-cnpj.util";
@Component({
  standalone: false,
  selector: 'app-project-register-visualization',
  templateUrl: './project-register-visualization.component.html',
  styleUrls: ['./project-register-visualization.component.scss']
})
export class ProjectRegisterVisualizationComponent implements OnInit {
  @ViewChild('content') content!: ElementRef;


  projectId: string | null = null;

  projectData: PsaProjectData | undefined;
  baselineActivity: string | undefined;
  developerPrincipal: Developer | undefined;
  othersDevelopers: Developer[] = [];
  locations: Locations[] = [];
  methodology: string | undefined;
  attachments: Attachment[] = [];
  odsSelecteds: Ods[] = [];

  /*Steper Status*/
  isProjectCompleted: boolean = false;
  isAuditCompleted: boolean = false;
  isReportCompleted: boolean = false;

  /** Serviço centralizado de funções do usuário */
  constructor(
    private routeActivate: ActivatedRoute,
    private router: Router,
    private projectService: ProjectService,
    private projectBaselineActivityService: ProjectBaselineActivityService,
    private projectMethodologiesService: ProjectMethodologiesService,
    // Removido FunctionNomeService,
    private datePipe: DatePipe,
    private modalService: AppModalService,
    private toastService: AppToastService,
    private psaAuthorizationService: PsaAuthorizationService
  ) { }
  isRegisteredCompleted: boolean = false;

  isProjectCompletedError: boolean = false;
  isAuditCompletedError: boolean = false;
  isReportCompletedError: boolean = false;
  isRegisteredCompletedError: boolean = false;

  steperSelectindex: number = 4;

  /*Botões Validation */
  isButtonAuditRejectProject: boolean = false;
  isButtonAuditApproveProject: boolean = false;

  isButtonUserRejectReport: boolean = false;
  isButtonUserAproveReport: boolean = false;

  isButtonCloneProject: boolean = false;

  formatDocument(value: string | undefined | null): string {
    return formatCPFOrCNPJ(value || '') || '-';
  }

  formatBiome(biome: string | undefined | null): string {
    if (biome === 'MATA_ATRANTICA') {
      return 'MATA ATLÂNTICA';
    }
    return biome || '-';
  }

  ngOnInit(): void {
    this.routeActivate.paramMap.subscribe(params => {
      this.projectId = params.get('id');
    });

    this.loadInitialData();
  }

  private resetSteper() {
    this.isProjectCompleted = false;
    this.isAuditCompleted = false;
    this.isReportCompleted = false;
    this.isRegisteredCompleted = false;

    this.isProjectCompletedError = false;
    this.isAuditCompletedError = false;
    this.isReportCompletedError = false;
    this.isRegisteredCompletedError = false;
  }

  private loadSteper() {
    this.resetSteper();

    if (this.projectData?.status === ProjectStatus.PROJECT_PENDING_AUDITOR_VALIDATION ||
      this.projectData?.status === ProjectStatus.PROJECT_ADJUSTED_BY_DEVELOPER
    ) {
      this.isProjectCompleted = true;
      this.steperSelectindex = 1;
    }

    if (this.projectData?.status === ProjectStatus.PROJECT_REJECTED_BY_AUDITOR
    ) {
      this.isProjectCompleted = true;
      this.isAuditCompletedError = true;
      this.steperSelectindex = 1;
    }

    if (this.projectData?.status === ProjectStatus.PROJECT_APPROVED_BY_AUDITOR ||
      this.projectData?.status === ProjectStatus.PROJECT_PENDING_DEVELOPER_CONFIRMATION
    ) {
      this.isProjectCompleted = true;
      this.isAuditCompleted = true;
      this.steperSelectindex = 2;
    }

    if (this.projectData?.status === ProjectStatus.PROJECT_REJECTED_BY_DEVELOPER
    ) {
      this.isProjectCompleted = true;
      this.isAuditCompleted = true;
      this.isReportCompletedError = true;
      this.steperSelectindex = 2;
    }

    if (this.projectData?.status === ProjectStatus.PROJECT_REGISTERED_IN_B3 ||
      this.projectData?.status === ProjectStatus.PROJECT_CONFIRMED_BY_DEVELOPER
    ) {
      this.isProjectCompleted = true;
      this.isAuditCompleted = true;
      this.isReportCompleted = true;
      this.isRegisteredCompleted = true;
      this.steperSelectindex = 3;
    }
  }

  private loadButtons() {
    this.disableAllButtons();
    const userFunctions = this.psaAuthorizationService.getFunctions();
    const hasAudit = userFunctions.some((f: any) => f.functionCode === 'CAR_PSA_AUDITA_PROJETO');
    const hasRegister = userFunctions.some((f: any) => f.functionCode === 'CAR_PSA_REGISTRA_PROJETO');

    if (hasAudit) {
      if (this.projectData?.status === ProjectStatus.PROJECT_PENDING_AUDITOR_VALIDATION) {
        this.isButtonAuditApproveProject = true;
        this.isButtonAuditRejectProject = true;
      }
    }

    if (hasRegister) {
      if (this.projectData?.status === ProjectStatus.PROJECT_PENDING_DEVELOPER_CONFIRMATION ||
        this.projectData?.status === ProjectStatus.PROJECT_APPROVED_BY_AUDITOR ||
        this.projectData?.status === ProjectStatus.PROJECT_REJECTED_BY_DEVELOPER
      ) {
        this.isButtonUserAproveReport = true;
        this.isButtonUserRejectReport = true;
      }
      if (this.projectData?.status === ProjectStatus.PROJECT_REJECTED_BY_AUDITOR ||
        this.projectData?.status === ProjectStatus.PROJECT_REJECTED_BY_DEVELOPER
      ) {
        this.isButtonCloneProject = true;
      }
    }
  }

  private disableAllButtons() {
    this.isButtonAuditRejectProject = false;
    this.isButtonAuditApproveProject = false;

    this.isButtonUserRejectReport = false;
    this.isButtonUserAproveReport = false;

    this.isButtonCloneProject = false;
  }

  loadInitialData() {
    this.loadProject().subscribe(projectResponse => {
      if (projectResponse) {
        this.projectData = this.parseProjectLoad(projectResponse);

        this.loadBaselinesActivity();
        this.loadMethodology();

        this.loadSteper();
        this.loadButtons();
      } else {
        console.error("Não foi possível obter os dados do projeto informado")
      }
    });
  }

  parseProjectLoad(project: PsaProjectData): PsaProjectData {
    let projectParsed: PsaProjectData = project;

    projectParsed = this.projectService.parseProjectStatus(projectParsed);

    let projectStartDate = this.datePipe.transform(projectParsed.projectStartDate, 'dd/MM/yyyy');
    projectParsed.projectStartDate = projectStartDate === null ? "00/00/0000" : projectStartDate;

    this.developerPrincipal = projectParsed?.developers?.find(d => d.principal);
    if (this.developerPrincipal) {
      const cpfCnpjDeveloperPrincipal = formatCPFOrCNPJ(this.developerPrincipal?.cpfCnpj || "") || "";
      this.developerPrincipal.cpfCnpj = cpfCnpjDeveloperPrincipal;
    }

    this.othersDevelopers = projectParsed?.developers?.filter(d => !d.principal) || [];

    this.locations = projectParsed?.locations?.map(location => {
      location.coordinates = `Latitude: ${location?.latitude} | Longitude: ${location?.longitude}`;
      return location;
    }) || [];

    this.attachments = projectParsed?.attachments || [];

    this.odsSelecteds = this.loadOds(projectParsed?.odsNumbers || []);

    projectParsed = this.validateIdShowReasonField(projectParsed);

    return projectParsed;
  }

  validateIdShowReasonField(project: PsaProjectData): PsaProjectData {
    if (project.status === ProjectStatus.PROJECT_REJECTED_BY_AUDITOR ||
      project.status === ProjectStatus.PROJECT_REJECTED_BY_DEVELOPER
    ) {
      project.showReason = true;
    }

    return project;
  }

  loadProject(): Observable<PsaProjectData | undefined> {
    return this.projectService.getProjectById(Number(this.projectId)).pipe(
      map((res) => res?.data || undefined),
      catchError(error => {
        console.error("Erro ao carregar projeto de crédito. Stack error: ", error);
        return [undefined];
      })
    );
  }

  loadBaselinesActivity(): void {
    this.projectBaselineActivityService.getBaselinesActivity().subscribe(response => {
      const baselinesActivity: any[] = response.data;
      const baselineActivityId = this.projectData?.baselineActivityId;
      const baselineActivity = baselinesActivity.find(
        b => b.baselineActivityIdentifier === baselineActivityId
      );
      this.baselineActivity = baselineActivity?.baselineActivityDescription || "";
    });
  }

  loadMethodology(): void {
    this.projectMethodologiesService.getMethodologies().subscribe(response => {
      const methodologies: any[] = response.data;
      const methodologyId = this.projectData?.methodologyId;
      const methodology = methodologies.find(m => m.methodologyIdentifier === methodologyId);
      this.methodology = methodology?.methodologyDescription || "";
    });
  }

  loadOds(odsNumbers: number[]): Ods[] {
    const odsDescriptions: { [key: number]: string } = {
      1: "1. Erradicação da pobreza",
      2: "2. Fome zero e agricultura sustentável",
      3: "3. Saúde e bem-estar",
      4: "4. Educação de qualidade",
      5: "5. Igualdade de gênero",
      6: "6. Água potável e saneamento",
      7: "7. Energia limpa e acessível",
      8: "8. Trabalho decente e crescimento econômico",
      9: "9. Indústria, inovação e infraestrutura",
      10: "10. Redução das desigualdades",
      11: "11. Cidades e comunidades sustentáveis",
      12: "12. Consumo e produção responsáveis",
      13: "13. Ação contra a mudança global do clima",
      14: "14. Vida na água",
      15: "15. Vida terrestre",
      16: "16. Paz, justiça e instituições eficazes",
      17: "17. Parcerias e meios de implementação",
    };

    return odsNumbers
      .filter(odsNumber => odsDescriptions[odsNumber] !== undefined)
      .map(odsNumber => ({ description: odsDescriptions[odsNumber] }));
  }



  /*Lógica para exportação/download de dados para .CSV*/
  exportToCSV() {
    if (this.projectData) {
      // Achatar os dados
      const flattenedData = this.flattenData(this.projectData);

      // Definir as colunas
      const headers = Object.keys(flattenedData);

      // Construir o CSV
      const csvContent =
        // Adicionar BOM para suporte a caracteres especiais no Excel
        '\ufeff' +
        headers.join(';') + '\n' +
        headers.map(field => this.formatCSVField(flattenedData[field])).join(';');

      // Criar Blob e fazer o download
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const filename = 'PSA_Projeto_Credito_' + this.projectData?.projectId + '.csv';
      this.downloadBlob(blob, filename);
      this.toastService.show({
        variant: 'success',
        label: 'Arquivo com detalhes exportado com sucesso!',
      });
    }
  }

  private flattenData(project: PsaProjectData): any {
    const developerPrincipal = project.developers?.find(d => d.principal);
    const othersDevelopers = project.developers?.filter(d => !d.principal) || [];
    const locations = project.locations || [];
    const attachments = project.attachments || [];

    const formatDeveloperPrincipal = (developer: Developer) =>
      `Nome:${developer.developerName},` +
      `CPF/CNPJ:${developer.cpfCnpj},` +
      `E-mail:${developer.email},` +
      `Telefone:${developer.phone}`.trim();

    const formatOthersDevelopers = (developer: Developer) =>
      `Nome:${developer.developerName},CPF/CNPJ:${developer.cpfCnpj}|`.trim();

    const formatLocation = (item: Locations) =>
      `Proprietário:${item.landOwnerFullName},` +
      `CPF/CNPJ:${item.landOwnerCpfCnpj},` +
      `Coordenadas:Latitude ${item.latitude} - Longitude ${item.longitude},` +
      `País:${item.country},` +
      `UF:${item.state},` +
      `Cidade:${item.municipality},` +
      `Hectares totais:${item.totalHectares},` +
      `Hectares de geração de carbono:${item.carbonGenerationHectares},` +
      `Hectares disponíveis:${item.availableHectares},` +
      `Bioma:${item.biome},` +
      `CAR. Registro de inscrição:${item.registrationRecord},` +
      `CAR. Link do demonstrativo online:${item.registrationRecordLink || ''}|`.trim();

    const formatAttachment = (item: Attachment) => `${item.link || ''}|`.trim();

    const formatOds = (item: Ods) => `${item.description} | `.trim();

    return {
      ID_DO_PROJETO: project.projectId,
      NOME_DO_PROJETO: project.projectName || '',
      CONTA_REGISTRADOR: project.registerCode || '',
      DATA_INICIO_PROJETO: project.projectStartDate || '',
      ATIVIDADE_LINHA_DE_BASE: this.baselineActivity || 'Conservação Florestal',
      DESCRICAO_DO_PROJETO: project.generalDetails || '',
      DESENVOLVEDOR_PRINCIPAL: developerPrincipal ? formatDeveloperPrincipal(developerPrincipal) : '',
      OUTROS_DESENVOLVEDORES: othersDevelopers.map(formatOthersDevelopers).join('\r\n'),
      PROPRIEDADES: locations.map(formatLocation).join('\r\n'),
      METODOLOGIA: this.methodology || '',
      RELATORIO_DE_ADEQUACAO_LINK: project.methodologyReportLink || '',
      RELATORIO_DE_ADEQUACAO_DESCRICAO: project.methodologyDocumentDescription || '',
      OUTROS_DOCUMENTOS_RELEVANTES_DESCRICAO: project.otherDocumentationDescription || '',
      OUTROS_DOCUMENTOS_RELEVANTES_LINKS: attachments.map(formatAttachment).join('\r\n'),
      ODS: project.odsNumbers ? this.loadOds(project.odsNumbers).map(formatOds).join('\r\n') : '',
      OUTROS_CO_BENEFICIOS: project.coBenefits || ''
    };
  }

  private formatCSVField(field: any): string {
    if (field === null || field === undefined) {
      return '';
    }

    // Se o campo contém vírgulas, aspas ou quebras de linha, ele deve ser envolvido por aspas.
    const fieldString = field.toString().replace(/"/g, '""'); // Escapa as aspas
    if (fieldString.search(/("|,|\n)/g) >= 0) {
      return `"${fieldString}"`;
    }

    return fieldString;
  }

  private downloadBlob(blob: Blob, filename: string) {
    const link = document.createElement('a');
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', filename);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }


  navigateToProjectConsult() {
    this.router.navigate(['/consulta-projeto']);
  }

  /*Lógica para as actions dos botões de acordo com o perfil do usuário*/
  actionAuditRejectProject() {
    this.modalService.open(ModalWithInputTextComponent, {
      modalTitleType: 'info',
      modalType: 'confirmation',
      actionType: 'reject',
      title: 'Deseja rejeitar o projeto?',
      content: `Digite o motivo para rejeitar a projeto`,
      closeButton: true
    }).afterClosed$.subscribe(result => {
      if (result?.data?.confirmation) {
        this.updateProjectStatus(result, ProjectStatusCode.PROJECT_REJECTED_BY_AUDITOR, false);
      }
    });
  }

  actionAuditAproveProject() {
    let msg = 'Deseja aprovar este projeto?';

    this.modalService.open(ModalConfirmationComponent, {
      modalTitleType: 'info',
      modalType: 'confirmation',
      title: 'Aprovar Projeto',
      content: msg,
      closeButton: true,
    }).afterClosed$.subscribe(result => {
      if (result?.data?.confirmation) {
        this.updateProjectStatus(result, ProjectStatusCode.PROJECT_PENDING_DEVELOPER_CONFIRMATION, true);
      }
    })
  }

  actionDeveloperRejectReportRecieved() {
    this.modalService.open(ModalConfirmationComponent, {
      modalTitleType: 'info',
      modalType: 'confirmation',
      title: 'Relatório de Monitoramento não recebido',
      content: `Deseja informar o não recebimento do Relatório de Monitoramento?`,
      closeButton: true
    }).afterClosed$.subscribe(result => {
      if (result?.data?.confirmation) {
        this.updateProjectStatus(result, ProjectStatusCode.PROJECT_REJECTED_BY_DEVELOPER, false);
      }
    });
  }

  actionDeveloperAproveReportRecivied() {
    let msg = 'Deseja confirmar o recebimento do parecer do auditor ao Relatório de Adequação à Metodologia?';

    this.modalService.open(ModalConfirmationComponent, {
      modalTitleType: 'info',
      modalType: 'confirmation',
      title: 'Confirmar Recebimento',
      content: msg,
      closeButton: true,
    }).afterClosed$.subscribe(result => {
      if (result?.data?.confirmation) {
        this.updateProjectStatus(result, ProjectStatusCode.PROJECT_REGISTERED_IN_B3, true);
      }
    })
  }

  actionCloneProject() {
    let msg = 'Deseja clonar este projeto?';

    this.modalService.open(ModalConfirmationComponent, {
      modalTitleType: 'info',
      modalType: 'confirmation',
      title: 'Clonar Projeto',
      content: msg,
      closeButton: true,
    }).afterClosed$.subscribe(result => {
      if (result?.data?.confirmation) {
        if (this.projectId) {
          this.loadProject().subscribe((project) => {
            if (project) {
              this.projectService.cloneProjectToDraft(project).subscribe((newDraft) => {
                if (newDraft) {
                  this.router.navigate(['/registro-projeto', newDraft.data?.projectId]);
                }
              });
            }
          });
        }
      }
    })
  }

  private updateProjectStatus(result: any, status: ProjectStatusCode, reasonNull: boolean) {
    const data: ProjectUpdateStatus = {} as ProjectUpdateStatus;

    if (reasonNull) {
      data.description = "";
    } else {
      data.description = result.data.reasonText;
    }

    data.status = status;

    if (this.projectId) {
      this.projectService.updateProjectStatus(Number(this.projectId), data).subscribe({
        next: () => {
          if (status === ProjectStatusCode.PROJECT_REJECTED_BY_DEVELOPER) {
            this.modalService.open(ModalConfirmationComponent, {
              modalTitleType: 'success',
              modalType: 'info-ok',
              title: 'O RM não foi recebido',
              content: 'Por favor, entre em contato com o auditor do projeto e confirme o recebimento do RM após o envio pelo auditor.',
              closeButton: false,
              buttonOk: true
            });
          }

          this.loadInitialData();
        },
        error: (err) => {
          console.error('Erro ao atualizar o status do projeto para ' + status, err);
        }
      });
    } else {
      console.error("Id do Projeto Inválido, não é possível atualizar o status do projeto para " + status)
    }
  }
}